export default __webpack_public_path__ + "static/media/faq1.835f0cd4.png";